<template>
  <DBox
    :id="'cmp-setting-identities-sidewindow_identities-shares_email_text_logo'"
    :addButton="false"
    :addLink="false"
  >
    <div
      class="
        cmp-setting-identities-sidewindow_identities-shares_email_text_logo
      "
    >
      <div class="form-group">
        <!-- <TextField
          :id="'logo_url'"
          v-bind="textFieldConfig"
          :value="text_element.logo_url"
          :placeholder="$t('logo_url')"
          @valuechanged="(name, value) => onTextValueChange(name, value)"
        /> -->
        <div class="template-container">
          <!-- <span v-html="$t('detailsb2b_logo_help1')"></span>
          <br />
          <br /> -->
          <!-- <span v-html="$t('detailsb2b_logo_help2')"></span>
          <br />
          <br />
          <br />
          <br />
          <br /> -->

          <span v-html="$t('detailsb2b_email_help1')"></span>
        </div>
      </div>
    </div>
  </DBox>
</template>
  <script>
import {
  createTextFieldConfig,
  EventHooks,
} from "../../../../plugins/text-field";
import DBox from "@dtplugins/dbox/dbox";
import { openWindow, sendMailHref } from "../../../../utility";
export default {
  components: { DBox },
  props: {
    invoiceProjectDetails: {
      type: Object,
    },
  },
  data() {
    return {
      textFieldConfig: createTextFieldConfig({
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
        valueChangedEvent: EventHooks.OnBlur,
      }),
    };
  },

  computed: {
    text_element: function () {
      return this.invoiceProjectDetails?.invoice_project?.text_elements || {};
    },
    template: function () {
      return;
    },
  },
  methods: {
    onRightMenuClick: async function (menu) {
      if (menu == "save") {
        this.$emit("updated", {
          text_elements: this.text_element,
          invoice_project_id:
            this.invoiceProjectDetails?.invoice_project?.invoice_project_id,
        });
      } else if (menu == "preview_email") {
        let template =
          this.invoiceProjectDetails?.invoice_project?.b2b_email_template;
        template = template
          .replace(
            "[% b2b_email_leading_text %]",
            this.text_element.b2b_leading || ""
          )
          .replace(
            "[% b2b_email_trailing_text %]",
            this.text_element.b2b_trailing || ""
          )
          .replace("[% logo_url %]", this.text_element.logo_url || "");

        let newWindow = window.open();
        newWindow.document.write(template);
      }
    },
    onTextValueChange: function (name, value) {
      this.text_element[name] = value;
    },
  },
};
</script>
  
  <style lang="scss">
.cmp-setting-identities-sidewindow_identities-shares_email_text_logo {
  padding: 10px 0px;
  .template-container {
    text-align: left;
    padding: 10px;
    height: fit-content;
  }
}
</style>
  